import { Component } from '@angular/core';
import { IzzyCredentialTypeExtensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Credential Type Extensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzycredentialtypeextension-form',
    templateUrl: './izzycredentialtypeextension.form.component.html'
})
export class IzzyCredentialTypeExtensionFormComponent extends BaseFormComponent {
    public record!: IzzyCredentialTypeExtensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'credentialExtensionDetails', sectionName: 'Credential Extension Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

